import { ref } from 'vue'
import { db } from '../firebase/config'
import { doc, collection, setDoc as setDocFn, addDoc as addDocFn, updateDoc as updateDocFn } from "firebase/firestore";
import { handleErrors } from '@/views/views_functions/errorHandler';

const useCollection = (collectionName) => {

  const error = ref(null)
  const isPending = ref(false)

  // add a new document
  const addDoc = async (doc) => {
    error.value = null
    isPending.value = true
    try {
      const docRef = await addDocFn(collection(db, collectionName), doc);
      isPending.value = false
      return docRef.id
    }
    catch (err) {
      handleErrors(err)
      console.log(err.message)
      error.value = 'could not send the message'
      isPending.value = false
    }
  }

  const useSubCollection = async (somename, data) => {
    const docRef = await addDoc(collection(db, collectionName, somename, 'my-volunteering'), data);
    return docRef
  }


  const setDoc = async (docId, docData) => {
    error.value = null;
    isPending.value = true;

    try {
      await setDocFn(doc(db, collectionName, docId), docData, { merge: true });
      isPending.value = false;
    } catch (err) {
      handleErrors(err)
      console.error(err.message);
      error.value = 'Could not set the document';
      isPending.value = false;
    }
  };

  const updateDoc = async (docId, updatedData) => {
    error.value = null;
    isPending.value = true;

    const docRef = doc(db, collectionName, docId)

    try {
      await updateDocFn(docRef, updatedData);
      isPending.value = false;
    } catch (err) {
      console.error(err.message);
      error.value = 'Could not update the document';
      isPending.value = false;
    }
  };

  return { error, addDoc, setDoc, updateDoc, isPending, doc, db, useSubCollection }

}

export default useCollection